/* ============================================================
   CART DOCK — compact bottom-center cart summary + fly-to-cart
   Replaces the old ns-smart-cart-drawer. On Add to Cart: a clone
   of the clicked product's image animates flying into the dock,
   the cart updates via AJAX (/cart/add.js, /cart.js), and a
   small capsule (expandable into a lightweight summary) shows
   the current cart — never a full-page drawer. Buy Now is left
   completely untouched (native form submit straight to checkout).
   ============================================================ */
(function () {
  "use strict";

  var dock, capsule, expandedPanel;
  var isExpanded = false;

  function moneyFmt(cents) {
    var val = (Number(cents) || 0) / 100;
    return "₹" + val.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1 ||
      (document.body && (
        document.body.classList.contains('template-product') ||
        (typeof document.body.className === 'string' && document.body.className.indexOf('product') !== -1)
      )) ||
      !!document.querySelector('#product-form, .pdp-sticky-bar, .pdp-main, .product-single');
  }

  function buildDock() {
    // Completely removed across whole website per user request
    var existing = document.getElementById("cart-dock");
    if (existing) existing.remove();
    dock = null;
    capsule = null;
    expandedPanel = null;
  }

  function setExpanded(val) {
    isExpanded = false;
  }

  function renderDock(cart) {
    var existing = document.getElementById("cart-dock");
    if (existing) existing.remove();
  }

  function bump() {
    // Dock capsule removed
  }

  function refreshCart(showBump) {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDock(cart);
        if (showBump) bump();
        var headerBadge = document.getElementById("cart-badge-count");
        if (headerBadge) {
          headerBadge.textContent = cart.item_count;
          headerBadge.style.display = cart.item_count > 0 ? "" : "none";
          headerBadge.classList.remove("bump");
          void headerBadge.offsetWidth;
          headerBadge.classList.add("bump");
        }
        var mbnBadge = document.getElementById("mbn-cart-count");
        if (mbnBadge) {
          mbnBadge.textContent = cart.item_count;
          mbnBadge.style.display = cart.item_count > 0 ? "flex" : "none";
        }
        var cartIcon = document.querySelector(".icon-cart");
        if (cartIcon) {
          cartIcon.classList.remove("cart-bounce");
          void cartIcon.offsetWidth;
          cartIcon.classList.add("cart-bounce");
        }
        return cart;
      });
  }

  /* ---- Fly-to-cart image animation ---- */
  function flyToCart(imgEl) {
    if (!imgEl || !capsule) return Promise.resolve();
    var startRect = imgEl.getBoundingClientRect();
    if (!startRect.width || !startRect.height) return Promise.resolve();

    var endRect = capsule.getBoundingClientRect();
    var clone = document.createElement("img");
    clone.src = imgEl.currentSrc || imgEl.src;
    clone.className = "cd-flying-clone";
    clone.style.left = startRect.left + "px";
    clone.style.top = startRect.top + "px";
    clone.style.width = startRect.width + "px";
    clone.style.height = startRect.height + "px";
    document.body.appendChild(clone);

    var endX = endRect.left + 20;
    var endY = endRect.top + endRect.height / 2 - 16;
    var midX = (startRect.left + endX) / 2;
    var midY = startRect.top - 100;

    return new Promise(function (resolve) {
      var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduce) { clone.remove(); resolve(); return; }

      function done() { clone.remove(); resolve(); }

      if (typeof gsap !== "undefined") {
        var tl = gsap.timeline({ onComplete: done });
        tl.to(clone, {
          left: midX,
          top: midY,
          width: startRect.width * 0.55,
          height: startRect.height * 0.55,
          duration: 0.42,
          ease: "power2.out",
        }).to(clone, {
          left: endX,
          top: endY,
          width: 30,
          height: 30,
          opacity: 0.25,
          duration: 0.4,
          ease: "power2.in",
        });
      } else {
        clone.style.transition =
          "left 0.8s cubic-bezier(.3,.6,.4,1), top 0.8s cubic-bezier(.3,.6,.4,1), width 0.8s ease, height 0.8s ease, opacity 0.8s ease";
        requestAnimationFrame(function () {
          clone.style.left = endX + "px";
          clone.style.top = endY + "px";
          clone.style.width = "30px";
          clone.style.height = "30px";
          clone.style.opacity = "0.25";
        });
        setTimeout(done, 820);
      }
    });
  }

  /* Called by drAddToCart (product-card quick add) after a successful add */
  window.DLTCartDock = {
    notify: function (sourceImgEl) {
      flyToCart(sourceImgEl);
      setTimeout(function () { refreshCart(true); }, 260);
    },
    /* Called after /cart page quantity/remove AJAX changes — no fly
       animation (there's no source thumbnail to fly from there), just
       resyncs the dock + header + bottom-nav badges. */
    refresh: function () {
      refreshCart(false);
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    buildDock();
    refreshCart(false);

    // PDP Add to Cart + Buy Now — handle via AJAX to avoid native /cart/add submission errors
    var pdpForm = document.getElementById("product-form");
    if (pdpForm) {
      pdpForm.addEventListener("submit", function (e) {
        var submitter = e.submitter || document.activeElement;
        var isBuyNow = submitter && (submitter.name === "checkout" || (submitter.classList && submitter.classList.contains("btn-buynow")));

        e.preventDefault();
        e.stopPropagation();

        var fd = new FormData(pdpForm);
        var variantId = fd.get("id") || (document.getElementById("selected-variant-id") || {}).value;
        var quantity = parseInt(fd.get("quantity"), 10) || parseInt((document.getElementById("qty-input") || {}).value, 10) || 1;
        var payload = { id: variantId, quantity: quantity };
        var btn = submitter || pdpForm.querySelector(".btn-buynow") || pdpForm.querySelector(".btn-icon-cart");
        var imgEl = document.getElementById("main-img2");
        var originalText = btn ? btn.textContent : "";

        if (btn) { btn.disabled = true; if (isBuyNow) btn.textContent = "Redirecting to Checkout..."; }
        if (!isBuyNow && imgEl) flyToCart(imgEl);

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (isBuyNow) {
              window.location.href = "/checkout";
            } else {
              return refreshCart(true);
            }
          })
          .catch(function () {
            if (isBuyNow) {
              window.location.href = "/checkout";
            }
          })
          .finally(function () {
            if (btn && !isBuyNow) { btn.disabled = false; btn.textContent = originalText; }
          });
      }, true);
    }
  });
})();
